import { useNavigate } from 'react-router';
import { Row, Text } from '~/commonComponents';
import { useAppSelector } from '~/hooks';
import EditPencilIcon from '~/images/icons/EditPencil';
import { Colors } from '~/themes/colors';

export const DraftPrompt = () => {
  const navigate = useNavigate();
  const draftCount = useAppSelector((state) => state.permanentJobs.draftCount);

  if (!draftCount || draftCount <= 0) return null;

  const message =
    draftCount === 1
      ? 'You have 1 draft in progress'
      : `You have ${draftCount} drafts in progress`;

  return (
    <Row
      alignItems="center"
      justifyContent="space-between"
      backgroundColor="rgba(0, 0, 0, 0.15)"
      paddingHorizontal={26}
      paddingVertical={12}
      data-testid="draft-prompt"
    >
      <Row alignItems="center" gap={8}>
        <EditPencilIcon color={Colors.white} size={16} />
        <Text color={Colors.white} fontSize={14}>
          {message}
        </Text>
      </Row>
      <Text
        bold
        color={Colors.white}
        fontSize={14}
        cursor="pointer"
        role="link"
        textDecoration="underline"
        onClick={() => navigate('/permanent-jobs/postings?status=draft')}
        data-testid="draft-prompt-continue-editing"
      >
        Continue editing &rarr;
      </Text>
    </Row>
  );
};
